import RowResumeText from "../../../../../../../components/RowResumeText";
import React from "react";
import {colors} from "../../../../../../../enums/colors";
import CustomChip from "../../../../../../../components/CustomChip";
import {useTranslation} from "react-i18next";
import {EMPTY_VALUES} from "../../../../../../../Apis/functions";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 22 de 01 de 2026
 */

const SummaryDetailsAttendanceGeoFence = ({
                                              item
                                          }) => {
    const { t } = useTranslation();
    const restrictionLabel =
        item?.morning ? t('morning_only_none')
            : item?.warning ? t('warning_mode_soft')
                : item?.restricted ? t('restricted_access_hard')
                    : EMPTY_VALUES.DEFAULT;
    return(
        <>
            <div className={'summary-container input-padding-top'}>
                <div className='row'>
                    <div className='col-12 p-0'>
                        <RowResumeText
                            title={t('name')}
                            value={item?.name}
                            tooltip={item?.name}
                            className='mb-4'
                        />
                    </div>
                    <div className='col-12 p-0'>
                        <RowResumeText
                            title={t('description')}
                            value={item?.description}
                            className='mb-4'
                        />
                    </div>
                    <div className='col-12 p-0'>
                        <RowResumeText
                            title={t('restriction')}
                            value={restrictionLabel}
                            className='mb-4'
                        />
                    </div>
                    <div className='col-12 p-0 mb-4'>
                        <RowResumeText
                            title={t('devices')}
                            className='mb-3'
                        />
                        {item?.devices &&
                            <div className='d-flex flex-wrap gap-2'>
                                {item?.devices.map((device)=>{
                                    return(
                                        <CustomChip
                                            key={device.id}
                                            background={colors.secondary100}
                                            fontColor={colors.secondary700}
                                            borderColor={colors.secondary150}
                                            legend={t(device?.label)}
                                            variant='compact'
                                        />
                                        )
                                    })
                                }
                        </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default SummaryDetailsAttendanceGeoFence
